import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { MuzeumPage } from '../muzeum/muzeum';
import { DataProvider } from '../../providers/data/data';
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  lang = [];
  urlCode;
  constructor(public navCtrl: NavController, public navParams: NavParams, private _DataProvider: DataProvider) {
    console.log('navParams-muzeum', this.navParams.get('muzeum'));
    this.urlCode = this.navParams.get('muzeum');
    console.log('',this._DataProvider.Muzeum);

  }
 
  ionViewDidLoad() {
    // this._DataProvider.setLocalStorage('muzeum',this.urlCode);

    this._DataProvider.setStatstic("login")
    this._DataProvider.currentPage = 'home'

    console.log('',this._DataProvider.Muzeum);
    this._DataProvider.menuShow = true;
    this._DataProvider.mapShow = true;
    this._DataProvider.showPad = false;


    this._DataProvider.getMuzeumByurlCodeFB(this.urlCode).subscribe((res:any) => {
      console.log("TopMenuComponent---res",res);
      console.log("TopMenuComponent---res",res.length);
      if(res.length != 0){
        this._DataProvider.Muzeum = res[0];
      }});


  }// emd of ionViewDidLoad


  enterToMuzium(lang) {

    setTimeout(() => {
      console.log('lang', lang);
      this._DataProvider.setLocalStorage('lang',lang);
      this._DataProvider.lang = lang;
      this._DataProvider.setLocalStorage('muzeum',this.urlCode);
      this.navCtrl.setRoot(MuzeumPage, {
        muzeum: this._DataProvider.Muzeum.urlCode
      })

      this._DataProvider.setStatstic("Enter lang")

    }, 200);
   
    //this.navCtrl.push(MuzeumPage, {lang: lang,MuzeumID:this.PublicMuzeums._id});
  }


staticgo(){

}


}




// WEBPACK FOOTER //
// ./src/pages/home/home.ts